import { render } from "./ChatterCoServices.vue?vue&type=template&id=0f6dbd3b&scoped=true&ts=true"
import script from "./ChatterCoServices.vue?vue&type=script&lang=ts"
export * from "./ChatterCoServices.vue?vue&type=script&lang=ts"

import "./ChatterCoServices.vue?vue&type=style&index=0&id=0f6dbd3b&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6dbd3b"]])

export default __exports__